import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";

const reasons = [
  "Academia de estudos e instituto de formação",
  "Instituto de formação, entidade certificada pela DGERT",
  "Wellbeing e desenvolvimento emocional",
  "Ambiente acolhedor e seguro",
  "Explicações individuais e em grupo",
  "Salas de estudo supervisionadas",
  "Pequenos grupos — atenção real",
  "Metodologia orientada para resultados",
  "Equipa especializada e empática",
  "Comunicação próxima com as famílias",
];

export const WhyChooseUs = () => {
  return (
    <section data-testid="why-choose-us" className="section bg-stone-50">
      <div className="container-tight">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <div className="relative">
            <motion.div
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="rounded-[2rem] overflow-hidden aspect-[4/5] shadow-[0_30px_70px_rgba(0,0,0,0.12)]"
            >
              <img
                src="https://images.pexels.com/photos/5212317/pexels-photo-5212317.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=720"
                alt="Explicação no Instituto Leopoldo Guimarães"
                className="h-full w-full object-cover"
              />
            </motion.div>
            <div className="absolute -bottom-6 -right-6 hidden md:block bg-bordeaux-700 text-white rounded-2xl p-6 shadow-[0_20px_50px_rgba(124,31,44,0.3)] max-w-[240px]">
              <div className="font-display text-3xl leading-none">12+</div>
              <div className="text-sm mt-1 text-white/85">anos a transformar percursos académicos.</div>
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <div className="text-[11px] uppercase tracking-[0.22em] font-semibold text-bordeaux-700 mb-4">Porquê o iLg</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-stone-900 leading-tight">
              Mais do que explicações — <span className="italic text-bordeaux-700">um caminho.</span>
            </h2>
            <p className="mt-5 text-stone-600 leading-relaxed">
              Reunimos numa única casa o que normalmente está disperso: rigor académico, acompanhamento
              próximo, certificação internacional e cuidado emocional.
            </p>

            <ul className="mt-9 grid sm:grid-cols-2 gap-x-6 gap-y-3">
              {reasons.map((r, i) => (
                <motion.li
                  key={r}
                  initial={{ opacity: 0, x: 10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.04 }}
                  className="flex items-start gap-3 text-stone-800"
                >
                  <span className="mt-0.5 inline-flex h-6 w-6 items-center justify-center rounded-full bg-bordeaux-700 text-white shrink-0">
                    <Check size={14} strokeWidth={2.5} />
                  </span>
                  <span className="text-sm sm:text-base">{r}</span>
                </motion.li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
